import { Button, Badge, Progress, TableProps, Tooltip, message } from "antd";
import { IReferredUser } from "./types";
import { CopyOutlined } from "@ant-design/icons";
import { copyToClipboard } from "../../../constants/copyToClipboard";
import { environment } from "../../../environments/environment";

export const getColumns = (): TableProps<IReferredUser>["columns"] => [
//   {
//     title: "User ID",
//     dataIndex: "userId",
//     key: "userId",
//     sorter: (a, b) => a.userId - b.userId,
//   },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: "Email",
    dataIndex: "registeredEmail",
    key: "registeredEmail",
    sorter: (a, b) => a.registeredEmail.localeCompare(b.registeredEmail),
  },
  {
    title: "Referral Code",
    dataIndex: "referralCode",
    key: "referralCode",
    sorter: (a, b) => a.referralCode.localeCompare(b.referralCode),
  },
   {
    title: "Refer Code Valid",
    dataIndex: "referCodeValid",
    key: "referCodeValid",
    render: (referCodeValid: boolean) => (
      <Badge status={referCodeValid ? "success" : "error"} text={referCodeValid ? "Valid" : "Invalid"} />
    ),
  },
  {
      title: "Step Completed",
      dataIndex: "stepCompleted",
      key: "stepCompleted",
      sorter: (a, b) => a.stepCompleted - b.stepCompleted,
    },
    {
      title: "Business Name",
      dataIndex: "businessName",
      key: "businessName",
      sorter: (a, b) => a.businessName.localeCompare(b.businessName),
    },
  {
    title: "Profile Status",
    dataIndex: "profileStatusId",
    key: "profileStatusId",
  },
 
  {
    title: "Is Freelancer",
    dataIndex: "isFreelancer",
    key: "isFreelancer",
    render: (isFreelancer: boolean) => (
      <Badge status={isFreelancer ? "success" : "default"} text={isFreelancer ? "Yes" : "No"} />
    ),
  },
  {
    title: "Invoices Created",
    dataIndex: "numberOfInvoicesCreated",
    key: "numberOfInvoicesCreated",
    sorter: (a, b) => a.numberOfInvoicesCreated - b.numberOfInvoicesCreated,
  },
  {
    title: "Invoices Paid",
    dataIndex: "numberOfInvoicesPaid",
    key: "numberOfInvoicesPaid",
    sorter: (a, b) => a.numberOfInvoicesPaid - b.numberOfInvoicesPaid,
  },
   {
    title: "Created Date",
    dataIndex: "createdDate",
    key: "createdDate",
    sorter: (a, b) => new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime(),
    render: (date: string) =>
      new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      })
  },
];

